'use strict';

var quickview = require('./quickview'),
    bornModules = require('./helpers/born.modules').default,
    product = require('./pages/product'),
    util = require('./util');

import {pdpOfferTimer} from './offertimer';
//set parent width as same as child to avoid jerk on sticky filters (web only)
function seoCatgryToggleHeight() {
        var $seoEle = $('#toggle_content');
        if($seoEle.length > 0){
            (parseInt($seoEle.height()) > 20) ? $('#top_toggle_link').removeClass('visually-hidden') : $('#top_toggle_link').addClass('visually-hidden');
        }
        let toggleBtn = $seoEle.find('.toggle-icon');
        let actualSEOContent = $seoEle.children().first();
        if(actualSEOContent.height() <= 40) {
            toggleBtn.hide();
        } else if(window.innerWidth > 768) {
            toggleBtn.show().css('opacity', '1');
        }
}

function debounce(callback, delay, timer) {
	clearTimeout(timer);
	timer = setTimeout(callback, delay);
}

//Catgory SEO ITem handling in mobile
$(document).on('click','.top-seoItem .seo-text-toggle',function(e){
        e.stopImmediatePropagation();
        $(this).closest('.top-seoItem').toggleClass('open');
        $('.top_toggle_content').toggle();
        seoCatgryToggleHeight();
});

$(document).on("click",".nohits-seocontent",function(){
    if($(window).width() < 767){
        $('#seo-mob').find('.cat-seo-text,.toggle--nb,.toggle__link').toggleClass('toggle--active');
    }
});

$(window).on('resize load', debounce(seoCatgryToggleHeight,700));

// cut paste the seo div while switching to mobile view or back - Search not found Page
function cutPasteSEO() {
    var $seoMob = $('#seo-mob');
    var $seoDesk = $('#seo-desktop');
    const doCutPaste = () => {
        var $seoContent = $('#refine-catseotexthead');
        if ($(window).width() > 767) {
            if ($seoContent.parent() !== $seoDesk) {
                $seoContent.remove();
                $seoDesk.html($seoContent);
                $seoContent.find('.cat-seo-text').addClass('toggle--active');
            }
        } else {
            if ($seoContent.parent() !== $seoMob) {
                $seoContent.remove();
                $seoMob.html($seoContent);
				setTimeout(() => {
					$('#seo-mob').find('.cat-seo-text,.toggle--nb,.toggle__link').addClass('toggle--active');
				}, 500);
            }
        }
    };
    doCutPaste();
    $(window).on('resize', doCutPaste);
}
function initQuickView() {
    // Default Dialog container class

    $('body').on('click', '.js-open-quickview', function (e) {
        e.preventDefault();
        var $dialogContainer = $("#QuickViewDialog"),
            url = $(this).attr('href'),
            isUpdateRequired = true;

        if ($dialogContainer.data('lastQuickViewURL') && $dialogContainer.data('lastQuickViewURL') === url) {
            isUpdateRequired = false;
        }

        $dialogContainer.data('lastQuickViewURL', url);

        var scrollTopDistance = $(document).scrollTop();
        window.quickViewProduct = false;
        quickview.show({
            url: url,
            source: 'quickview',
            isUpdateRequired: true,
            keepAlive: false,
            callback: function() {
                product.init();
                bornModules.carousel.init();
                bornModules.video.init();
                bornModules.selectTags.init();
                bornModules.qtyControl.init();
                bornModules.modalToggle.init();
                bornModules.toggle.init();
                bornModules.showMoreSwatches.init('.quickview__dialog .swatch-variation-wrap');
                if (util.isMobile()) {
                    setTimeout(function() {
                        $('.overlay--active').scrollTop(0);
                    }, 100);
                }
                initMoQuickEvents();
                var addToCartBtn=$('.pdp.quickview__dialog .add-to-cart');
                if(addToCartBtn.length > 0) {
                    addToCartBtn.attr('disabled', false);
                }
                pdpOfferTimer(true);
            }
        });
    });

    if(SitePreferences.ENABLE_IMAGE_LAZYLOAD) {
    	$(function() {
    		$("img.product__img:not(.unveil-loaded)").unveil(300, function() {
	       		$(this).addClass('unveil-loaded');
	        });
        });
    }
}

function initMoQuickEvents()
{
    let items = $('.quickview__dialog .sharing__item');
    if(items.length > 0 && typeof initMoengageShareEvents !== "undefined") {
         initMoengageShareEvents(items); 
    }
}

/**
 * @private
 * @function
 * @description Initializes events on the product-tile for the following elements:
 * - quickview
 */
function initializeEvents() {
    $(".plp-recommendations-nohitwrapper").length > 0 ? cutPasteSEO() : "";
    initQuickView();
    seoCatgryToggleHeight();
    $(document).on('click','.bck--flx',function(e){
        e.stopPropagation();
    });
}

$(document).on('click','.toggle-icon',function(e){
    const $toggleContent = $('#toggle_content');
    $(this).toggleClass('toggle-icon-down toggle-icon-up');
    if ($toggleContent.hasClass('collapsed')) {
        $toggleContent.removeClass('collapsed').addClass('expanded');
        $(this).text('');
    } else {
        $toggleContent.removeClass('expanded').addClass('collapsed');
        $(this).text('...');
    }
})

exports.init = function () {
    initializeEvents();
};





// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/product-tile.js